import Component from 'routes/AskMeQuestions/Detail'
import api, { getUserFromCtx } from 'shared/api'

const defaultProps = {}
const propTypes = {}

export async function getServerSideProps(context) {
  const user = getUserFromCtx(context)
  const { query } = context
  const { questionId } = query

  try {
    const requests = [
      api.get(`/public/questions/${questionId}`, {
        headers: {
          Authorization: `Bearer ${user?.accessToken}`,
        },
      }),
      api.get(`/public/questions/${questionId}/answers?page=1&limit=10`, {
        headers: {
          Authorization: `Bearer ${user?.accessToken}`,
        },
      }),
    ]

    const [
      { data },
      {
        data: questionsList,
        headers: { 'x-total-results': questionsTotal },
      },
    ] = await Promise.all(requests)

    return {
      props: {
        questionId,
        accessToken: user?.accessToken || null,
        data,
        questionsData: {
          list: questionsList,
          total: questionsTotal,
        },
        seoConfig: {
          image:
            'https://imagedelivery.net/WEWiZyGwyq-Q4qn_WluYYg/9e3eb6c7-748d-471e-ee77-a14ae8ca9600/public',
          title: data?.title,
          content: data?.text,
        },
      },
    }
  } catch (e) {
    return {
      props: {
        errorCode: 404,
      },
    }
  }
}

export const Page = props => <Component {...props} />

Page.defaultProps = defaultProps
Page.propTypes = propTypes

export default Page
